import React from 'react';
import PropTypes from 'prop-types';

const FaceExcellent = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g id="face--excellent" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <path d="M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M12,23.1111111 C18.1364972,23.1111111 23.1111111,18.1364972 23.1111111,12 C23.1111111,5.86350278 18.1364972,0.888888889 12,0.888888889 C5.86350278,0.888888889 0.888888889,5.86350278 0.888888889,12 C0.888888889,18.1364972 5.86350278,23.1111111 12,23.1111111 Z M12,20.8888889 C7.51694899,20.8888889 3.55555556,16.9834227 3.55555556,12.8888889 L3.55555556,12.4444444 L20.4444444,12.4444444 L20.4444444,12.8888889 C20.4444444,16.9834227 16.483051,20.8888889 12,20.8888889 Z M12,20 C15.8303133,20 19.2613637,16.7730018 19.5376352,13.3333333 L4.46236482,13.3333333 C4.73863625,16.7730018 8.16968668,20 12,20 Z" id="Combined-Shape" fill={color} fillRule="nonzero"></path>
      </g>
    </svg>
  );
}

FaceExcellent.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

FaceExcellent.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default FaceExcellent;



// WEBPACK FOOTER //
// ./src/components/Icons/FaceExcellent.jsx